<template>
  <div id="service-order-data" class="h-100">
    <div  class="card ccs-card-radius border-0 w-100 mb-0 pb-2">
      <div v-if="wz_case.pattern_email === 'J'">
        <div class="card-body mt-3 mb-0 pb-0">
          <p class="card-title mulish ml-5 mb-0 pb-0">{{wz_case.fax_content}}</p>
        </div>
        <hr class="hr-ccs-thin">
        <div class="card-body">
          <div class="card-body mt-0 pt-0 mb-3 pb-0">
            <p class="card-subtitle">{{ $t('wz_case_form.wz5_form.choose_one') }}</p>
          </div>
          <div class="card-body error-block pb-0 pt-0" v-if="v_error">
            <div  class="alert-error" role="alert">
              <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.6591 1.48148C12.5186 -0.493826 9.6675 -0.493829 8.52705 1.48148L0.401382 15.5556C-0.739062 17.5309 0.686492 20 2.96738 20H19.2187C21.4996 20 22.9252 17.5309 21.7847 15.5556L13.6591 1.48148ZM9.23145 6.00195L10.1824 12.5627L12.0049 12.5618L12.9494 6.00012L9.23145 6.00195ZM9.55579 13.2628L9.55727 16.281L12.6337 16.2794L12.6322 13.2613L9.55579 13.2628Z" fill="#FF0000"/>
              </svg>
              {{ v_validation_error }}
            </div>
          </div>
          <div class="card-body mt-0 pt-0 mb-0 pb-0">
            <div class="row">
              <div class="col-xxl-4 col-lg-4 col-md-12 col-sm-12">
                <div class="form-check mt-2">
                  <input v-model="params.replace_device_agreement"
                         :value=true
                         id="replace_device_agreement_1" checked="checked"
                         class="form-check-input replace_device_agreement"
                         type="checkbox"
                         @change="checkedOnClick('replace_device_agreement_1', 'replace_device_agreement');">
                  <label class="form-check-label" for="replace_device_agreement_1">{{ $t('wz_case_form.wz5_form.pattern_J_agree') }}</label>
                </div>
                <div class="form-check mt-2">
                  <input v-model="params.replace_device_agreement"
                         :value=false
                         id="replace_device_agreement_2"
                         class="form-check-input replace_device_agreement"
                         type="checkbox"
                         @change="checkedOnClick('replace_device_agreement_2', 'replace_device_agreement');">
                  <label class="form-check-label" for="replace_device_agreement_2">{{ $t('wz_case_form.wz5_form.pattern_J_not_agree') }} &nbsp;
                    <button class="show-desktop show-addition-info" onclick="$('.additional_info_j').toggle();">
                      <svg fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="21px" height="21px" viewBox="0 0 416.979 416.979" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M356.004,61.156c-81.37-81.47-213.377-81.551-294.848-0.182c-81.47,81.371-81.552,213.379-0.181,294.85 c81.369,81.47,213.378,81.551,294.849,0.181C437.293,274.636,437.375,142.626,356.004,61.156z M237.6,340.786 c0,3.217-2.607,5.822-5.822,5.822h-46.576c-3.215,0-5.822-2.605-5.822-5.822V167.885c0-3.217,2.607-5.822,5.822-5.822h46.576 c3.215,0,5.822,2.604,5.822,5.822V340.786z M208.49,137.901c-18.618,0-33.766-15.146-33.766-33.765 c0-18.617,15.147-33.766,33.766-33.766c18.619,0,33.766,15.148,33.766,33.766C242.256,122.755,227.107,137.901,208.49,137.901z"></path> </g> </g></svg>
                    </button>
                    <button class="show-mobile show-addition-info" @click="showAdditionalPopupEPattern()">
                      <svg fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="21px" height="21px" viewBox="0 0 416.979 416.979" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M356.004,61.156c-81.37-81.47-213.377-81.551-294.848-0.182c-81.47,81.371-81.552,213.379-0.181,294.85 c81.369,81.47,213.378,81.551,294.849,0.181C437.293,274.636,437.375,142.626,356.004,61.156z M237.6,340.786 c0,3.217-2.607,5.822-5.822,5.822h-46.576c-3.215,0-5.822-2.605-5.822-5.822V167.885c0-3.217,2.607-5.822,5.822-5.822h46.576 c3.215,0,5.822,2.604,5.822,5.822V340.786z M208.49,137.901c-18.618,0-33.766-15.146-33.766-33.765 c0-18.617,15.147-33.766,33.766-33.766c18.619,0,33.766,15.148,33.766,33.766C242.256,122.755,227.107,137.901,208.49,137.901z"></path> </g> </g></svg>
                    </button>
                  </label>
                </div>
              </div>
              <div class="col-xxl-8 col-lg-8 col-md-12 col-sm-12 additional_info_j p-2">
                <b>{{ $t('wz_case_form.wz2_form.warning_start') }}&nbsp; </b> {{ $t('wz_case_form.wz5_form.additional_info_j') }}
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="card-body mt-4">
      <button v-if="showButton" class="send" @click="verifyForm()"> {{ $t('wz_case_form.wz2_form.send') }}</button>
      <button v-else class="send disabled" disabled="disabled"> {{ $t('wz_case_form.wz2_form.send') }}</button>
    </div>
  </div>

  <app-confirmation-modal-new-style
      :message="confirm_message"
      ref="confirmationModal"
      @confirm="saveWz5Form"
  />
  <app-additional-info-modal
      :message="additional_info_message"
      ref="additionalInfoModal"
      @close="close()"
  />
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {Wz5FormProcess} from "@/mixins/Wz5FormProcess";
import {Wz5FormValidator} from "@/mixins/Wz5FormValidator";
export default {
  name: "Wz5Details",
  data() {
    return {
      additional_info: false,
      params: this.getDefaultParams(),
      showButton: false,
      confirm_message: "Czy na pewno chcesz przesłać odpowiedź?",
      additional_info_message: ''
    }
  },
  mixins: [Wz5FormProcess, Wz5FormValidator],
  created() {
    if (this.wz_case.wz_number === 'WZ5') {
      document.getElementById('footer').style.display = 'none';
    }
  },
  mounted() {
    this.params.current_form = this.wz_case.pattern_email;
    this.params.fax_id = this.wz_case.fax_id;
  },
  computed: {
    ...mapGetters('Wz5Form', {wz5_form: 'wz5_form'}),
    ...mapGetters('WzCase', {wz_case: 'wz_case', wz_case_decision: 'wz_case_decision'}),
  },
  methods: {
    ...mapActions('Wz5Form', {updateWz5Form: 'updateWz5Form'}),
    getDefaultParams() {
      return {
        decision: '',
        replace_device_agreement: '',
        decision_answer: '',
        current_form: '',
        fax_id: ''
      }
    },
    showConfirmation() {
      this.$refs.confirmationModal.show();
    },
    verifyForm() {
      if (this.validateWz5BeforeShowSendButton()) {
        this.showConfirmation();
      }
    },
    checkedOnClick(el_id, class_name){
      this.v_error = false;
      let checkedElement = document.getElementById(el_id);
      let checkedElementInfo = checkedElement.checked;
      let checkboxesList = document.getElementsByClassName(class_name);
      for (let i = 0; i < checkboxesList.length; i++) {
        checkboxesList.item(i).checked = false;
      }
      this.showButton = false;
      if (checkedElementInfo === true) {
        checkedElement.checked = true;
        this.params.decision = checkedElement.value;
        this.showButton = true;
      } else {
        this.params.decision = '';
      }
    },
    showAdditionalPopupEPattern() {
      this.additional_info_message = this.$t('wz_case_form.wz5_form.additional_info_j')
      this.$refs.additionalInfoModal.show();
    }
  }
}
</script>

<style scoped>
  #additional-elements .form-switch input,
  #additional-elements .form-switch label {
    cursor: pointer;
  }
  #recommendations-table tr {
    margin-bottom: 10px;
  }
  #recommendations-table td {
    padding: 0.25rem 0.5rem;
    margin: 0;
  }
  #recommendations-table td p {
    margin: 0;
  }

  .ccs-card table {
    margin-bottom: 0.5rem!important;
  }

  .ccs-card .footer table {
    border-collapse: separate;
    border-spacing: 8px 0;
  }

  .ccs-card .footer table td {
    padding: 0!important;
  }

  @media (min-width: 576px) {
    .text-sm-justify {
      text-align: justify;
    }
  }
  .hr-ccs-thin {
    border: 0.01em solid #B4B4B4
  }
  .ml-5 {
    margin-left: 15px;
  }
  .card-title {
    font-family: Mulish;
    font-size: 20px;
    font-weight: 700;
    line-height: 25.1px;
    text-align: left;
    color: #4E4E4E;
  }
  .card-subtitle {
    font-family: Mulish;
    font-size: 14px;
    font-weight: 700;
    line-height: 17.57px;
    text-align: left;
    color: #4E4E4E;
  }
  .form-check-input {
    width: 15px;
    height: 15px;
  }
  .additional_info, .additional_info_j {
    display: none;
    margin-top: 20px;
    border-radius: 20px;
    border: 2px solid #23AE84;
    align-content: center;
    justify-content: center;
    padding: 10px;
  }
  .additional_info_j {
    display: none;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    margin-top: 50px;
  }
  .disabled {
    opacity: 0.5;
  }
  .ccs-card-radius {
    box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.15);
  }
  .form-check-label {
    font-family: Mulish;
    font-size: 16px;
    font-weight: 400;
    line-height: 20.08px;
    text-align: left;
    color: #4E4E4E;
  }
  @media (max-width: 768px) {
    .card-title {
      font-size: 14px;
      line-height: 18px;
    }
    .additional_info {
      font-size: 12px;
      display: none;
    }
    .form-check {
      margin-bottom: 20px;
    }
    .form-check label {
      font-size: 14px;
    }
    .send {
      width: 80%;
      height: 42px;
      border-radius: 20px;
      background-color: #23AE84;
      color: #ffffff;
      border: none;
      font-weight: 600;
      font-size: 14px;
      margin-left: 10%;
      margin-right: 10%;
    }
    .show-desktop {
      display: none;
    }
    .show-mobile {
      display: inline-block;
    }
    .error-block {
      min-height: 35px;
    }
  }
  @media (min-width: 768px) {
    .form-check label {
      font-size: 16px;
    }
    .send {
      width: 106px;
      height: 42px;
      border-radius: 20px;
      background-color: #23AE84;
      color: #ffffff;
      border: none;
      font-weight: bold;
      font-size: 14px;
      float: right;
    }
    .show-desktop {
      display: inline-block;
    }
    .show-mobile {
      display: none;
    }
    .additional_info {
      font-weight: 600;
    }
    .error-block {
      min-height: 25px;
    }
  }
  .form-check .form-check-input {
    margin-left: -25px;
  }
  .form-check-input {
    width: 17px;
    height: 17px;
  }
  .hr-ccs-thin {
    border: 0.33px solid #B4B4B4
  }
  .alert-error {
    color: red;
    font-family: Mulish;
    font-size: 16px;
    position: absolute;
    right: 0;
    top: -10px;
    padding-right: 17px;
    padding-left: 17px;
  }
  .error-block {
    position: relative;
    height: 25px;
  }
  .show-addition-info {
    border: none;
    background: none;
  }
  input:focus,
  select:focus,
  textarea:focus,
  button:focus {
    outline: none;
  }
</style>
